import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark mr-1 text-warning" }, null, -1)
const _hoisted_6 = { class: "col-md-9" }
const _hoisted_7 = { class: "text-lg-right" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "fa fa-chevron-left mr-2" }, null, -1)
const _hoisted_9 = { class: "card mt-4" }
const _hoisted_10 = { class: "form-wrap" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { for: "" }
const _hoisted_15 = { disabled: "" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { for: "" }
const _hoisted_21 = { class: "input-btn" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_23 = { class: "mb-0" }
const _hoisted_24 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "inline-items" }
const _hoisted_27 = { for: "" }
const _hoisted_28 = { class: "inline-items mb-2" }
const _hoisted_29 = { class: "mr-3" }
const _hoisted_30 = { class: "form-check form-check-inline" }
const _hoisted_31 = {
  for: "",
  title: "Phase Name"
}
const _hoisted_32 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_33 = { class: "accordion-wrap" }
const _hoisted_34 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_35 = { class: "mb-0" }
const _hoisted_36 = { class: "card-body border mt-3 rounded p-3 share-block" }
const _hoisted_37 = { class: "absolute-text" }
const _hoisted_38 = { class: "inline-items" }
const _hoisted_39 = {
  class: "form-check-label",
  for: "inlineCheckbox11"
}
const _hoisted_40 = {
  key: 0,
  class: "alert alert-danger rounded mb-3 text-center p-2"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = { class: "form-check form-check-inline" }
const _hoisted_44 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_45 = { class: "form-group mt-3" }
const _hoisted_46 = { class: "modal-wrap default-modal" }
const _hoisted_47 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "sendInvitation",
  tabindex: -1,
  "aria-labelledby": "sendInvitation",
  "aria-hidden": "true"
}
const _hoisted_48 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_49 = { class: "modal-content" }
const _hoisted_50 = { class: "modal-header" }
const _hoisted_51 = { class: "d-block" }
const _hoisted_52 = {
  class: "modal-title",
  id: "sendInvitation"
}
const _hoisted_53 = { class: "text-muted" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_55 = { class: "modal-body" }
const _hoisted_56 = { class: "form-wrap pt-0" }
const _hoisted_57 = {
  key: 0,
  class: "form-group"
}
const _hoisted_58 = { class: "block-element" }
const _hoisted_59 = { class: "shadowed-box rounded mt-3 member-box" }
const _hoisted_60 = /*#__PURE__*/_createVNode("span", { class: "small-icon-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-user-check" })
], -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode()
const _hoisted_62 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_63 = { class: "text-success to-upper" }
const _hoisted_64 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_65 = { class: "text-danger" }
const _hoisted_66 = /*#__PURE__*/_createTextVNode()
const _hoisted_67 = {
  key: 2,
  class: "mt-1"
}
const _hoisted_68 = { class: "text-primary" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode()
const _hoisted_70 = { class: "modal-footer" }
const _hoisted_71 = { class: "modal-wrap default-modal" }
const _hoisted_72 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successfulModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_73 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_74 = { class: "modal-content text-center" }
const _hoisted_75 = { class: "msg-header" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_77 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_78 = { class: "msg-body" }
const _hoisted_79 = {
  class: "alert alert-success text-center",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListBreadCrumb = _resolveComponent("ToDoListBreadCrumb")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_ToDoListBreadCrumb, {
      project: _ctx.state.data.project,
      breadCrumbEndPoint: _ctx.state.data.endPoint
    }, null, 8, ["project", "breadCrumbEndPoint"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('invitation_members')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn outline d-inline-block mr-2 mb-1",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToInvitation && _ctx.redirectToInvitation(...args)))
            }, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('go_back')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.errorList,
          hasError: _ctx.state.isErrorStatus
        }, null, 8, ["errors", "hasError"]),
        _createVNode("div", _hoisted_11, [
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('invite_existing_member')), 1),
              _withDirectives(_createVNode("select", {
                class: "form-control",
                disabled: _ctx.state.data.exitingUserList && !_ctx.state.data.exitingUserList.length,
                id: "user.id",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.selectExitingUser = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeExistingMember && _ctx.changeExistingMember(...args)))
              }, [
                _createVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('select_member')), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.exitingUserList, (item, itemIndex) => {
                  return (_openBlock(), _createBlock("option", {
                    value: item,
                    key: itemIndex
                  }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                }), 128))
              ], 40, ["disabled"]), [
                [_vModelSelect, _ctx.state.data.selectExitingUser]
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.users, (user, userIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "email-tag",
                  key: userIndex
                }, [
                  _createVNode("p", _hoisted_16, [
                    _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                    }, [
                      _hoisted_17
                    ], 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('invite_new_member_email')), 1),
              _createVNode("div", _hoisted_21, [
                _withDirectives(_createVNode("input", {
                  type: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.inviteNewMember = $event)),
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  placeholder: "Type email and press enter or click add button",
                  fdprocessedid: "033rmd",
                  autocomplete: "off",
                  onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.state.data.inviteNewMember]
                ]),
                _createVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args))),
                  fdprocessedid: "dpvnhr"
                }, [
                  _hoisted_22
                ])
              ]),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.invite.invites, (invite, inviteIndex) => {
                return (_openBlock(), _createBlock("div", {
                  key: inviteIndex,
                  class: "email-tag"
                }, [
                  _createVNode("p", _hoisted_23, [
                    _createTextVNode(_toDisplayString(invite) + " ", 1),
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                    }, [
                      _hoisted_24
                    ], 8, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_25, [
          _createVNode("div", _hoisted_26, [
            _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('select_phase')), 1),
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.state.data.selectPhase,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.selectPhase = $event)),
              mode: "tags",
              searchable: true,
              placeholder: _ctx.$t('select_phase'),
              select: _ctx.state.data.selected,
              options: _ctx.state.data.phaseList,
              "close-on-select": true,
              "create-option": true
            }, null, 8, ["modelValue", "placeholder", "select", "options"])
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.phaseTaskList, (phase, phaseIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "alert alert-primary rounded mb-2 p-3",
            key: phaseIndex
          }, [
            _createVNode("div", _hoisted_28, [
              _createVNode("ul", null, [
                _createVNode("li", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _withDirectives(_createVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      "onUpdate:modelValue": ($event: any) => (phase.isChecked = $event),
                      onChange: ($event: any) => (_ctx.phaseCheck(phaseIndex, phase.isChecked))
                    }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                      [_vModelCheckbox, phase.isChecked]
                    ]),
                    _createVNode("label", _hoisted_31, _toDisplayString(phase.name), 1)
                  ])
                ]),
                _createVNode("li", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.attributes, (att, attIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "form-check form-check-inline",
                      key: attIndex
                    }, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        disabled: att.code=='name',
                        "onUpdate:modelValue": ($event: any) => (att.isChecked = $event),
                        onChange: ($event: any) => (_ctx.checkPhaseRole(phaseIndex, attIndex))
                      }, null, 40, ["disabled", "onUpdate:modelValue", "onChange"]), [
                        [_vModelCheckbox, att.isChecked]
                      ]),
                      _createVNode("label", _hoisted_32, [
                        _createVNode("small", null, _toDisplayString(att.name), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(phase.tasks, (task, taskIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "card rounded mb-2",
                    key: taskIndex
                  }, [
                    _createVNode("div", {
                      class: "card-header bg-white p-0 border-0",
                      id: `heading${task.uuid}`
                    }, [
                      _createVNode("h2", _hoisted_35, [
                        _createVNode("button", {
                          class: "btn btn-link btn-block text-left collapsed p-0",
                          type: "button",
                          "data-toggle": "collapse",
                          "data-target": `#collapse${task.uuid}`,
                          "aria-expanded": "false",
                          "aria-controls": `collapse${task.uuid}`
                        }, [
                          _withDirectives(_createVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => (task.isChecked = $event),
                            onChange: ($event: any) => (_ctx.checkTask(phaseIndex, taskIndex, task.isChecked))
                          }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                            [_vModelCheckbox, task.isChecked]
                          ]),
                          _createTextVNode(" " + _toDisplayString(task.name), 1)
                        ], 8, ["data-target", "aria-controls"])
                      ])
                    ], 8, ["id"]),
                    _createVNode("div", {
                      id: `collapse${task.uuid}`,
                      class: "collapse",
                      "aria-labelledby": `heading${task.uuid}`,
                      "data-parent": "#accordionExample"
                    }, [
                      _createVNode("div", _hoisted_36, [
                        _createVNode("div", _hoisted_37, [
                          _createVNode("small", null, _toDisplayString(_ctx.$t('things_to_share')), 1)
                        ]),
                        _createVNode("div", _hoisted_38, [
                          _createVNode("ul", null, [
                            _createVNode("li", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(task.attributes, (attTask, attTaskIndex) => {
                                return (_openBlock(), _createBlock("div", {
                                  class: "form-check form-check-inline",
                                  key: attTaskIndex
                                }, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    disabled: attTask.code=='name',
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => (attTask.isChecked = $event),
                                    onChange: ($event: any) => (_ctx.checkTaskRole(phaseIndex, taskIndex, attTaskIndex))
                                  }, null, 40, ["disabled", "onUpdate:modelValue", "onChange"]), [
                                    [_vModelCheckbox, attTask.isChecked]
                                  ]),
                                  _createVNode("label", _hoisted_39, [
                                    _createVNode("small", null, _toDisplayString(attTask.name), 1)
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ], 8, ["id", "aria-labelledby"])
                  ]))
                }), 128))
              ])
            ])
          ]))
        }), 128)),
        (_ctx.state.data.phaseTaskList.length == 0)
          ? (_openBlock(), _createBlock("div", _hoisted_40, [
              _createVNode("p", null, [
                _hoisted_41,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('no_one_phase_selected')), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_42, [
          _createVNode("div", _hoisted_43, [
            _withDirectives(_createVNode("input", {
              class: "form-check-input",
              type: "checkbox",
              id: "inlineCheckbox2",
              value: "true",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.isIndividualAccept = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.state.data.isIndividualAccept]
            ]),
            _createVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('individual_acceptance_required')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_45, [
          _createVNode("button", {
            type: "submit",
            class: "btn default-btn d-inline-block mr-2",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.verifyInvitation && _ctx.verifyInvitation(...args)))
          }, _toDisplayString(_ctx.$t('send')), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_46, [
      _createVNode("div", _hoisted_47, [
        _createVNode("div", _hoisted_48, [
          _createVNode("div", _hoisted_49, [
            _createVNode("div", _hoisted_50, [
              _createVNode("div", _hoisted_51, [
                _createVNode("h5", _hoisted_52, _toDisplayString(_ctx.$t('send_invitation')), 1),
                _createVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('send_invitation_are_as_below')) + ". ", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.hideSendInvitation && _ctx.hideSendInvitation(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_54
              ])
            ]),
            _createVNode("div", _hoisted_55, [
              _createVNode("div", _hoisted_56, [
                _createVNode("div", null, [
                  (
                    _ctx.state.data.invitationProjectVerify.newMemberList &&
                    _ctx.state.data.invitationProjectVerify.newMemberList.length
                  )
                    ? (_openBlock(), _createBlock("div", _hoisted_57, [
                        _createVNode("p", null, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('invite_members_below')) + ".", 1)
                        ]),
                        _createVNode("ul", _hoisted_58, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                        .invitationProjectVerify.newMemberList, (regMember, index) => {
                            return (_openBlock(), _createBlock("li", { key: index }, [
                              _createVNode("div", _hoisted_59, [
                                _createVNode("p", null, [
                                  _hoisted_60,
                                  _hoisted_61,
                                  _createVNode("small", null, [
                                    _createVNode("strong", null, _toDisplayString(regMember.email), 1)
                                  ])
                                ]),
                                (regMember.new.length)
                                  ? (_openBlock(), _createBlock("p", _hoisted_62, [
                                      _createVNode("strong", _hoisted_63, _toDisplayString(_ctx.$t('new')) + " : ", 1),
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(regMember.new, (task, taskIndex) => {
                                        return (_openBlock(), _createBlock("span", {
                                          class: "badge bg-primary text-white mr-2 mb-1",
                                          key: taskIndex
                                        }, _toDisplayString(task.name), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (regMember.pending.length)
                                  ? (_openBlock(), _createBlock("p", _hoisted_64, [
                                      _createVNode("strong", _hoisted_65, _toDisplayString(_ctx.$t('pending')) + " : ", 1),
                                      _hoisted_66,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(regMember.pending, (task, taskIndex) => {
                                        return (_openBlock(), _createBlock("span", {
                                          class: "badge bg-primary text-white mr-2 mb-1",
                                          key: taskIndex
                                        }, _toDisplayString(task.name), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (regMember.shared.length)
                                  ? (_openBlock(), _createBlock("p", _hoisted_67, [
                                      _createVNode("strong", _hoisted_68, _toDisplayString(_ctx.$t('shared')) + " :", 1),
                                      _hoisted_69,
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(regMember.shared, (task, taskIndex) => {
                                        return (_openBlock(), _createBlock("span", {
                                          class: "badge bg-primary text-white mr-2 mb-1",
                                          key: taskIndex
                                        }, _toDisplayString(task.name), 1))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_70, [
              _createVNode("div", null, [
                (
                  (_ctx.state.data.invitationProjectVerify.newMemberList &&
                    _ctx.state.data.invitationProjectVerify.newMemberList.length) ||
                  (_ctx.state.data.invitationProjectVerify.pendingMemberList &&
                    _ctx.state.data.invitationProjectVerify.pendingMemberList.length)
                )
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.sendInvitation && _ctx.sendInvitation(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.sendInvitation ? _ctx.$t('sending') : _ctx.$t('send')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_71, [
      _createVNode("div", _hoisted_72, [
        _createVNode("div", _hoisted_73, [
          _createVNode("div", _hoisted_74, [
            _createVNode("div", _hoisted_75, [
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeSuccessModal && _ctx.closeSuccessModal(...args))),
                onKeydown: _cache[13] || (_cache[13] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSuccessModal && _ctx.closeSuccessModal(...args)), ["esc"])),
                "aria-label": "Close"
              }, [
                _hoisted_76
              ], 32),
              _hoisted_77
            ]),
            _createVNode("div", _hoisted_78, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('successful')) + "!", 1),
              _createVNode("div", _hoisted_79, _toDisplayString(_ctx.state.data.successFulMessage), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}